import {
  withRequiredAuthInfo,
  WithLoggedInAuthInfoProps,
} from "@propelauth/react";
import React, { useContext, useEffect, useState } from "react";
import CompanyBaseViewForm from "./CompanyBaseViewForm";
import { BuilderProfile, DeveloperProfile } from "../../models/company";
import { UserContext } from "../../contexts/UserContext";
import { getCompanyProfile } from "../../api/company_api";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";
import ClaimCompanyBanner from "../CompanySetup/ClaimCompanyBanner";
import { SharePointIntegrationCard } from "./SharePointIntegrationCard";


function CompanyBaseView({ ...props }: WithLoggedInAuthInfoProps) {
  const context = useContext(UserContext);
  const [companyProfile, setCompanyProfile] = useState<
    BuilderProfile | DeveloperProfile | null
  >(null);

  useEffect(() => {
    const fetchCompanyProfile = async () => {
      try {
        if (!context?.company_id) {
          throw new Error("Company ID is not available");
        }
        if (!props.accessToken) {
          throw new Error("Access token is not available");
        }
        getCompanyProfile(context.company_id, props.accessToken as string).then(
          (companyData) => {
            setCompanyProfile(companyData);
            console.log('comapny_data', companyData)
          }
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchCompanyProfile();
  }, []);

  if (companyProfile === null) {
    return <BaseLoadingSpinner/>
  }

  return (
    <div>
      {!companyProfile.claimed && (
        <ClaimCompanyBanner companyName={context?.company_name} />
      )}
      <CompanyBaseViewForm companyProfile={companyProfile} />
      {context?.company_id && companyProfile.id === context.company_id &&  (
        <SharePointIntegrationCard company_id={companyProfile.id} />
      )}
    </div>
  );
}

export default withRequiredAuthInfo(CompanyBaseView);
